import React, { useState } from "react";
import { Link } from "react-router-dom";
import MegaMenu from "./mega-menu/MegaMenu";
import MegaMenuMobile from "./mega-menu/MegaMenuMobile";
import ClientDemo from "../demo/ClientDemo";


const HeaderThree = () => {
  
  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    if (window.scrollY >= 68) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  window.addEventListener("scroll", changeBackground);
    
  return (
    <>
      <div
        className={
          navbar
            ? "theme-main-menu sticky-menu theme-menu-two bg-none fixed"
            : "theme-main-menu sticky-menu theme-menu-two bg-none"
            
        }
        style={{ paddingTop: "1px", paddingBottom: "1px"}}
      >
        <div className="d-flex align-items-center justify-content-center">
          <div className="logo">
            <Link to="/">
              <img src="\images\logo\clientctrl500.png" alt="clientctrl" style={{width:'53%',paddingLeft:'10px'}}/>
            </Link>
          </div>
          {/* End Logo */}

          <nav id="mega-menu-holder" className="navbar navbar-expand-lg" style={{paddingRight:'0'}}>
            <div className="container nav-container">
              <div
                className="navbar-collapse collapse"
                id="navbarSupportedContent"
              >
                <div className="d-lg-flex justify-content-between align-items-center">
                  <MegaMenu />
                  {/* End MegaMenu */}

                  <ul className="right-widget">
                    <li className="d-sm-flex">

                      <ul className="user-login-button d-flex align-items-center justify-content-center">
                        {/* <li >
                          <Link to="/login" className="signIn-action" >
                            <b>Login</b>
                          </Link>
                        </li> */}
                        <li>
                          <ClientDemo />
                        </li>
                      </ul>
                      {/* End ul */}
                    </li>
                  </ul>
                  {/* End right-button-group  */}
                </div>
              </div>
            </div>
          </nav>
          {/* End nav */}
        </div>

        <MegaMenuMobile />
        {/* 	End Mega Menu for Mobile */}
      </div>
      
      
      {/* /.theme-main-menu */}
    </>
  );
};

export default HeaderThree;
